const { REACT_APP_BACKEND_HOST } = process.env;

export const RETAILERS_SETTING_LOOKUP_API_URL = `${REACT_APP_BACKEND_HOST}/retailsettings/api/Lookup`;
export const FETCH_STATES_API_URL = `${RETAILERS_SETTING_LOOKUP_API_URL}/states?CountryId=`;
export const FETCH_DISTRICTS_API_URL = `${RETAILERS_SETTING_LOOKUP_API_URL}/districts?StateId=`;
export const FETCH_CITIES_API_URL = `${RETAILERS_SETTING_LOOKUP_API_URL}/cities?DistrictId=`;

export const RETAILERS_STORE_BASE_URL = `${REACT_APP_BACKEND_HOST}/retailstore/api/Retailer`;
export const FETCH_RETAILERS_STORE_CAMPAIGNS_URL = `${RETAILERS_STORE_BASE_URL}/campaigns`;
